import type { EnumObject } from "./types";

export function isEnum<T extends EnumObject>(
  enumObject: T,
  value: string | null,
): value is Extract<keyof T, string> {
  return value !== null && value in enumObject;
}
